/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimezoneMetadata } from './TimezoneMetadata';
import {
    TimezoneMetadataFromJSON,
    TimezoneMetadataFromJSONTyped,
    TimezoneMetadataToJSON,
    TimezoneMetadataToJSONTyped,
} from './TimezoneMetadata';

/**
 * 
 * @export
 * @interface BuiltInUserResponse
 */
export interface BuiltInUserResponse {
    /**
     * 
     * @type {string}
     * @memberof BuiltInUserResponse
     */
    userTimezone?: string;
    /**
     * Indicates if the request was successful
     * @type {boolean}
     * @memberof BuiltInUserResponse
     */
    success?: boolean;
    /**
     * Error message if the request failed
     * @type {string}
     * @memberof BuiltInUserResponse
     */
    error?: string;
    /**
     * 
     * @type {TimezoneMetadata}
     * @memberof BuiltInUserResponse
     */
    timezoneMetadata?: TimezoneMetadata;
    /**
     * 
     * @type {any}
     * @memberof BuiltInUserResponse
     */
    data?: any | null;
    /**
     * 
     * @type {string}
     * @memberof BuiltInUserResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the BuiltInUserResponse interface.
 */
export function instanceOfBuiltInUserResponse(value: object): value is BuiltInUserResponse {
    return true;
}

export function BuiltInUserResponseFromJSON(json: any): BuiltInUserResponse {
    return BuiltInUserResponseFromJSONTyped(json, false);
}

export function BuiltInUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BuiltInUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userTimezone': json['userTimezone'] == null ? undefined : json['userTimezone'],
        'success': json['success'] == null ? undefined : json['success'],
        'error': json['error'] == null ? undefined : json['error'],
        'timezoneMetadata': json['timezone_metadata'] == null ? undefined : TimezoneMetadataFromJSON(json['timezone_metadata']),
        'data': json['data'] == null ? undefined : json['data'],
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function BuiltInUserResponseToJSON(json: any): BuiltInUserResponse {
    return BuiltInUserResponseToJSONTyped(json, false);
}

export function BuiltInUserResponseToJSONTyped(value?: BuiltInUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userTimezone': value['userTimezone'],
        'success': value['success'],
        'error': value['error'],
        'timezone_metadata': TimezoneMetadataToJSON(value['timezoneMetadata']),
        'data': value['data'],
        'message': value['message'],
    };
}

